const listenForNavToggler = () => {
    if(document.querySelector('.navbar-toggler')){
        const allToggler = document.querySelectorAll('.navbar-toggler');
        allToggler.forEach(toggler =>{
            toggler.addEventListener('click', ev =>{
                let nav = toggler.closest('.navbar');
                nav.classList.toggle('stoof-navbar-backdrop');
                const theMenu = nav.querySelector('.stoof-main-nav');
                if (toggler.classList.contains('collapsed')) {
                    document.body.classList.remove('menu-open');
                    let scrollTo = toggler.getAttribute('data-scroll-y');
                    console.log(scrollTo, 'scrollTo');
                    window.scrollTo({top: scrollTo * 1, left: 0, behavior: "instant"});
                } else {
                    toggler.setAttribute('data-scroll-y', window.scrollY);
                    document.body.classList.add('menu-open');
                    // make sure top of menu is visible on smaller mobile screens that require menu scrolling (column-reverse issue)
                    setTimeout(()=>{
                        theMenu.scrollTop = -theMenu.scrollHeight;
                    }, 500)

                }
            })

        })

    }
}
export default listenForNavToggler;